import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-stool",
  "use": "icon-th-stool-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-stool\">\n<path d=\"M25 8V5C25 4.46957 24.7893 3.96086 24.4142 3.58579C24.0391 3.21071 23.5304 3 23 3H9C8.46957 3 7.96086 3.21071 7.58579 3.58579C7.21071 3.96086 7 4.46957 7 5V8C7 8.53043 7.21071 9.03914 7.58579 9.41421C7.96086 9.78929 8.46957 10 9 10H9.83L7.0125 27.8438C6.97112 28.1056 7.03544 28.3732 7.19132 28.5877C7.3472 28.8022 7.58187 28.946 7.84375 28.9875C7.89541 28.9958 7.94767 29 8 29C8.23788 28.9997 8.46785 28.9145 8.64861 28.7599C8.82937 28.6052 8.94908 28.3912 8.98625 28.1562L9.96 22H22.04L23.0125 28.1562C23.0497 28.3914 23.1696 28.6056 23.3506 28.7603C23.5316 28.9149 23.7619 28.9999 24 29C24.0528 29.0001 24.1054 28.9959 24.1575 28.9875C24.4194 28.946 24.6541 28.8022 24.8099 28.5877C24.9658 28.3732 25.0301 28.1056 24.9888 27.8438L22.17 10H23C23.5304 10 24.0391 9.78929 24.4142 9.41421C24.7893 9.03914 25 8.53043 25 8ZM9 5H23V8H9V5ZM21.7237 20H10.2762L11.855 10H20.145L21.7237 20Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-stool.svg
// module id = DSYe
// module chunks = 84